import moment from "moment";

/**
 * Given a date, extract keys based on the date
 * @param {moment.MomentInput} date
 * @returns { month: string, date: string }
 * `month` - This is actually `yearMonth`, as in `YYYY-MM`
 * `date` - ISO-8601 short date format date `YYYY-MM-DD`
 * NOTE: `date` may be one off from the given date, since we use `local()` here
 * For example, "2023-02-15T06:42:48.483Z" may return
 * a day before: `2023-02-14` in timezones west of UTC.
 */
export const getShiftKeys = (date: moment.MomentInput): Record<"month" | "date", string> => {
  const momentDate = moment(date).local();
  return {
    month: momentDate.format("YYYY-MM"),
    date: momentDate.format("YYYY-MM-DD"),
  };
};
